module.exports = __webpack_public_path__ + "img/brain.6955de1f.png";